import ReactDOM from 'react-dom';

const elContainerMap = new WeakMap();

export function portalContainer(el) {
    if (!el) {
        return () => null;
    }

    const prevResult = elContainerMap.get(el);

    if (prevResult) {
        return prevResult;
    }

    const result = function Container({children}) {
        return ReactDOM.createPortal(children, el);
    };

    elContainerMap.set(el, result);

    return result;
}